module.exports = __webpack_public_path__ + "img/Down.08f08d5c.svg";